function updateProgressSale()
{
  var totalSaleItems = $('.color-selection__grid-item[data-salecount]').length;
  var leftSaleItems = $('.color-selection__grid-item[data-salecount]:not(:has(.color-selection__image.coladded))').length;

  //$('.color-selection__grid-item[data-salecount]').show();
  //$('.color-selection__grid-item[data-salecount]').hide();
}

 

function setProgressBar(total, filled) {
    const progressBarFill = document.querySelector('.progress-bar-fill');
    const percentage = (filled / total) * 100;
    progressBarFill.style.width = `${percentage}%`;


  $('.color-selection__selection-container .color-selection__grid .color-selection__image').removeClass('bk-border');
  $('.color-selection__selection-container .color-selection__grid .color-selection__image:not(.coladded)').first().addClass('bk-border');

}
function updateComp()
  {
    var comp = 0; 
var array = document.querySelectorAll('input.hidden-color.active'); 
for (var i = 0; i < array.length; i++){ 
if(array[i].getAttribute('comp'))
{
var value = parseInt(array[i].getAttribute('comp')); 
comp += value;
}
}
 
var percentage2 = ((comp - mainPrice)*100)/comp;
    
percentage2 = parseInt(percentage2);
if(percentage2<0 || isNaN(percentage2))percentage2=0; 
    
$('.product-meta__label-list.label-list span.label.label--highlight span').html(percentage2+"%");
    
var finalPrice = Shopify.formatMoney(comp, Shopify.money_format);
$('.product-meta__price-list-container span.price.price--compare').html(finalPrice); 
  }


function updateProgress(){
   
      
        var totalFilledColor = $('.hidden-color.active[value!=""]').length;
      var totalToBeFilled = parseInt($('#pick-color-id').attr('custom-toshow'));
            setProgressBar(totalToBeFilled,totalFilledColor);

$('.greyedText .selectedColor').text(totalFilledColor);
 
      
      if (totalFilledColor == totalToBeFilled) {
     
       $('.hidden-overlay').click();
        $('#AddToCart').removeAttr('disabled');
        $('.remover_upsell').removeAttr('disabled');
       
        $('.template-product-nailkit').addClass('allfill');
        $('.custom-fixed-footer button').removeAttr('disabled');
        $('#StickyAddToCart').removeClass('disabled');
        $('#StickyAddToCart .loader-button__text').text(window.translationsText.stickyFilled); 
      }   else{

 $('#StickyAddToCart').addClass('disabled');
        $('#StickyAddToCart .loader-button__text').text($('#AddToCart .disabled-text').text());
                $('.template-product-nailkit').removeClass('allfill');
      setTimeout(function(){
      $('#AddToCart').attr('disabled','true');
        $('.custom-fixed-footer button').attr('disabled','true');
        
     },100);
    
    }


// update compare price  
updateComp()
}

$(document).ready(function(){
  
  $('.color-selection__image--top').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    var count = $(this).closest('.color-selection__grid-item').data('count');
    

    if($(this).hasClass('itemSaleProduct')){
      $('.color-selection__selection-container').addClass('saleProducts');
    }else{
      $('.color-selection__selection-container').removeClass('saleProducts');
    }

    if($(this).hasClass('saleProduct2')){
      $('.color-selection__selection-container').addClass('saleProduct2');
    }else{
      $('.color-selection__selection-container').removeClass('saleProduct2');
    }
    
    
    if($(this).closest('.color-selection__grid-item').hasClass('active')){
      $('.color-selection__grid-item.active').removeClass('active');
      $('.color-selection__selection-container').hide();
	
      $('body').removeClass('color-choose-active');
   
    }
    else{
    $('.color-selection__grid-item.active').removeClass('active');
    $(this).closest('.color-selection__grid-item').addClass('active');
    $(`.color-selection__selection-container`).css('display', 'flex');
      
      $('body').addClass('color-choose-active');
      
    }
    

    
  });


  
  
  
  $('.color-selection__selection-grid-item.clickable').click(function(event) { 
    if($(this).data('disable') == undefined){ 
      $('.color-selection__selection-grid-item.clickable').attr('data-disable',true);
      var $file = $(this).children('.color-selection__image').data('file');
      var $colorName = $(this).children('.color-selection__image').data('name');
        var $variantId = $(this).children('.color-selection__image').data('variant');
      var $comp = $(this).children('.color-selection__image').data('comp'); 
      //lets find first unselected index instead 
      var count = $('.hidden-color.active[value=""]:eq(0)').data('color-index'); //$(this).parent('.color-selection__selection-container').data('count');  
      var totalCount = $('.color-selection__grid-item').data('total-count'); 
      var $input = $(`#color${count}`); 
      var $img = $(`.color-selection__grid-item[data-count=${count}]`).children('.color-selection__image--top');
            var $title = $(`.color-selection__grid-item[data-count=${count}]`).children('.farbe-title');
            $(`.color-selection__grid-item[data-count=${count}]`).children('.color-selection__image--top').find('.color-selection-ad-text').remove();
  
            $input.val($colorName);
            $input.attr('variant-id',$variantId);
            $input.attr('variant-img',$file);
            $input.attr('comp',$comp); 
      $img.css('backgroundImage', `url(${$file})`);
      $title.text($colorName);
      //  $img.css('backgroundColor', '#fff');
      $img.addClass('coladded');
      
      updateProgress();
      
      setTimeout(function(){$('.color-selection__selection-grid-item.clickable').removeAttr('data-disable');},50); 
    }else{
      event.stopPropagation();
    }
  });











    $('.color-selection__selection-grid-item.clickable2').click(function(event) { 
    if($(this).data('disable') == undefined){ 
      $('.color-selection__selection-grid-item.clickable2').attr('data-disable',true);
      var $file = $(this).children('.color-selection__image').data('file');
      var $colorName = $(this).children('.color-selection__image').data('name');
      var $variantId = $(this).children('.color-selection__image').data('variant');
      var $comp = $(this).children('.color-selection__image').data('comp'); 
      var $newPrice = $(this).children('.saleItemPrice').html();
      //lets find first unselected index instead 
      var count = $(`.color-selection__grid-item.active`).data('salecount'); //$(this).parent('.color-selection__selection-container').data('count');  
      var totalCount = $('.color-selection__grid-item').data('total-count'); 
      var $input = $(`#colorsale${count}`); 
      var $img = $(`.color-selection__grid-item.active`).children('.color-selection__image--top');
            var $title = $(`.color-selection__grid-item.active`).children('.farbe-title');
      var $priceArea = $(`.color-selection__grid-item.active`).children('.price-item');
            $(`.color-selection__grid-item.active`).children('.color-selection__image--top').find('.color-selection-ad-text').remove();
 
            $input.val($colorName);
            $input.attr('variant-id',$variantId);
            $input.attr('variant-img',$file);
            $input.attr('comp',$comp); 
      $input.addClass('active');
      $img.css('backgroundImage', `url(${$file})`);
      $title.text($colorName);
      //  $img.css('backgroundColor', '#fff');
      $img.addClass('coladded');

      $priceArea.html($newPrice);
      
      updateProgressSale();
      $('.color-selection__selection-container.saleProducts').hide();
      $('body').removeClass('color-choose-active');
      
      setTimeout(function(){$('.color-selection__selection-grid-item.clickable2').removeAttr('data-disable');},50); 
    }else{
      event.stopPropagation();
    }
  });
  
  

  
  $('#StickyAddToCart').click(function(ev){
ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();


    $('html, body').animate({
    scrollTop: $(".product__info form.shopify-product-form").offset().top - 50
 }, 750);


    setTimeout(function(){$('#MainPaymentContainer').trigger('click')},650);
          //if($(this).hasClass('disabled')){  }
  });
  


  
  $('body').on('click','#MainPaymentContainer',function(evt){
    if($(this).find('#AddToCart').attr('disabled') == 'disabled'){ 

      evt.preventDefault();
      evt.stopImmediatePropagation();
      $('.color-selection__image.color-selection__image--top.pi-1').trigger('click');

};


});
  $('.color-choose-filter').click(function(evt){

    evt.preventDefault();
    evt.stopImmediatePropagation();
$(this).parents('.color-selection__selection-container').find('.color-choose-filter').removeClass('text--underlined');
$(this).addClass('text--underlined');


let offSet = ($(this)[0].offsetLeft);
   // $('.color-filter-link-bar .link-bar__scroller').scrollLeft(offSet);

   $('.color-filter-link-bar .link-bar__scroller').animate({
        scrollLeft: ($(this).position().left + $('.color-filter-link-bar .link-bar__scroller').scrollLeft()) - 100 
    }, 500);

    
    var filterVal = $(this).data('tag');

       $(this).parents('.color-selection__selection-container').find('.color-selection__selection-grid-item.clickable').hide().filter('.' + filterVal).show();
    
    
    
  });


  $('body').on('click','.custom-new-upsell',function(evt){
    if($(this).find('.remover_upsell').attr('disabled') == 'disabled'){ 

      evt.preventDefault();
      evt.stopImmediatePropagation();
      $('.color-selection__image.color-selection__image--top.pi-1').trigger('click');
    }
  });

  $('.color-selection__arrow.close_icon_svg').click(function(evt){
    if($(this).hasClass('saleItemClose'))
    {
      evt.preventDefault();evt.stopImmediatePropagation(); 
      var $parent = $(this).parents('.color-selection__grid-item'); 
      //lets find first unselected index instead 
      var count = $parent.data('salecount'); 
      var totalCount = $('.color-selection__grid-item').data('total-count'); 
      var $input = $(`#colorsale${count}`); 
      var $img = $parent.children('.color-selection__image--top'); 

       if($(this).hasClass('saleItem2'))
       {
         $parent.children('.farbe-title').text(`${window.translationsText.farbeSale2}`);
       }else{
         $parent.children('.farbe-title').text(`${window.translationsText.farbeSale}`);
       }
 
      
      $input.val('');
      $input.removeAttr('variant-id');
      $input.removeAttr('comp');
      $input.removeAttr('variant-img');
      $input.removeClass('active');
      $img.removeAttr('style');
      $img.removeClass('coladded'); 
      $parent.children('.price-item').html('');
      updateProgressSale() 
      
    }else{
    evt.preventDefault();evt.stopImmediatePropagation(); 
      var $parent = $(this).parents('.color-selection__grid-item'); 
      //lets find first unselected index instead 
      var count = $parent.data('count'); 
      var totalCount = $('.color-selection__grid-item').data('total-count'); 
      var $input = $(`#color${count}`); 
      var $img = $(`.color-selection__grid-item[data-count=${count}]`).children('.color-selection__image--top'); 
          $(`.color-selection__grid-item[data-count=${count}]`).children('.farbe-title').text(`${window.translationsText.farbe} ${count}`); 
             $input.val('');
            $input.removeAttr('variant-id');
           $input.removeAttr('comp');
            $input.removeAttr('variant-img');
      $img.removeAttr('style');
      $img.removeClass('coladded'); 
      updateProgress() 
    }
  });

 

      
  document.addEventListener('variant:changed', function(event) {

    updateProgress();

  });
  
  $("body").click(function(event){
    if(!$(event.target).is('.color-selection__selection-container')&&!$(event.target).is('.color-selection__selection-grid-item')&&!$(event.target).is('.color-selection__selection-grid-item *')&&!$(event.target).is('.link-bar .container')&&!$(event.target).is('.link-bar')&&!$(event.target).is('.link-bar__linklist')&&!$(event.target).is('.link-bar__scroller')&&!$(event.target).is('.link-bar__link-item')&& !$(event.target).is('.color-choose-filter')&&!$(event.target).is('.color-selection__image--top') &&!$(event.target).is('#MainPaymentContainer .disabled-text') &&!$(event.target).is('#MainPaymentContainer #AddToCart')  && !$(event.target).is('.color-selection-pi-text') && !$(event.target).is('.color-tool-tip')&& !$(event.target).is('.changeSelectionImage')&& !$(event.target).is('img.smallSelectionImage') ){
      $('.color-selection__grid-item.active').removeClass('active');
      $('.color-selection__selection-container').hide();
    $('body').removeClass('color-choose-active');
    }
  })
  


  setProgressBar(parseInt($('#pick-color-id').attr('custom-toshow')),$('.hidden-color.active[value!=""]').length);
   $('#AddToCart').attr('disabled','true');
  $('#StickyAddToCart').addClass('disabled');
  $('#AddToCart').append(`<span class='disabled-text'>${window.translationsText.buttonUnfilled}</span>`);
        $('#StickyAddToCart .loader-button__text').text($('#AddToCart .disabled-text').text());

  
});



function buyBundle()
{
var items = []; 
var array = document.querySelectorAll('input.hidden-color.active'); 
for (var i = 0; i < array.length; i++){
 
var value = parseInt(array[i].getAttribute('variant-id'));
   
var item = {
quantity:1,
id:value,
properties: {
        "Für": mainTitle
 }
}

var checkQty = true;
for (var j = 0; j < items.length; j++){
if(items[j].id == value)
{
items[j].quantity = items[j].quantity + 1;
checkQty = false; 
}
}
  
if(checkQty)
{
items.push(item); 
}
  
}

// add main product
  
items.push(mainItem); 



/* now checking sale Items */

var array2 = document.querySelectorAll('input.hidden-sale-color.active'); 
for (var i = 0; i < array2.length; i++){
 
var value = parseInt(array2[i].getAttribute('variant-id'));
   
var item = {
quantity:1,
id:value
}

var checkQty = true;
for (var j = 0; j < items.length; j++){
if(items[j].id == value)
{
items[j].quantity = items[j].quantity + 1;
checkQty = false; 
}
}
  
if(checkQty)
{
items.push(item); 
}
  
}
/* checking sale items end */
  
console.log(items);


// EG EDIT
fetch('/cart/add.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
}).then(response => {
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return response.json();
}).then(data => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));
    document.getElementById('mini-cart').open = true;
})
.catch(error => {
    alert("Bitte versuche es erneut.");
    console.error('There was a problem with the fetch operation:', error);
});

// $.ajax({
// type: 'POST',
// url: '/cart/add.js',
// data: {items},
// dataType: 'json', 
// success: function (data) { 
// document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//  bubbles: true
// }));
// document.getElementById('mini-cart').open = true;
//  },
// error: function()
//   {
// alert("Bitte versuche es erneut.")
//   }
//  }); 
  
}




function changeImageSelection(index)
  {
    if(document.querySelector('.product-form.test.newBundle')){
    document.querySelector('.product-form.test.newBundle').dataset.selectionimage = index;

      $('img.smallSelectionImage').removeClass('active');
      $('img.smallSelectionImage.img'+index).addClass('active');
    }
  }



function checkVariantBundle(maxNumbers)
{ 
  
  document.querySelector('div#pick-color-id').setAttribute('custom-toshow',maxNumbers);
  $('.color-selection__grid-item').attr('data-total-count',maxNumbers);

  $('input.hidden-color').removeClass('active');
  $('input.hidden-color').each(function(index) {
  if(index<maxNumbers){$(this).addClass('active');}
  });

  $('span.totalColor').text(maxNumbers);

  $('.color-selection__grid.more-colors-grid .color-selection__grid-item').css('display','none');
  $('.color-selection__grid.more-colors-grid .color-selection__grid-item').each(function(index) {
  if(index<maxNumbers){$(this).css('display','block');}
  });
 
}






function refreshBtn()
  {
            var totalFilledColor = $('.hidden-color.active[value!=""]').length;
      var totalToBeFilled = parseInt($('#pick-color-id').attr('custom-toshow'));
            setProgressBar(totalToBeFilled,totalFilledColor);

$('.greyedText .selectedColor').text(totalFilledColor);
 
      
      if (totalFilledColor == totalToBeFilled) {
     
       $('.hidden-overlay').click();
        $('#AddToCart').removeAttr('disabled');
        $('.remover_upsell').removeAttr('disabled');
       
        $('.template-product-nailkit').addClass('allfill');
        $('.custom-fixed-footer button').removeAttr('disabled');
        $('#StickyAddToCart').removeClass('disabled');
        $('#StickyAddToCart .loader-button__text').text(window.translationsText.stickyFilled); 
      }   else{

 $('#StickyAddToCart').addClass('disabled');
        $('#StickyAddToCart .loader-button__text').text($('#AddToCart .disabled-text').text());
                $('.template-product-nailkit').removeClass('allfill');
      setTimeout(function(){
      $('#AddToCart').attr('disabled','true');
        $('.custom-fixed-footer button').attr('disabled','true');
        
     },100);
    
    }
  }
    document.addEventListener("DOMContentLoaded", (event) => {
 refreshBtn();setTimeout( refreshBtn,200);setTimeout( refreshBtn,300);setTimeout( refreshBtn,400);setTimeout( refreshBtn,500);setTimeout( refreshBtn,1000)
}); 